export default __webpack_public_path__ + "static/media/green-air-balloon.421fa726.svg";